"use client";

import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import accessURL from "../../../../components/utils/superAccess";
import { toast } from "react-toastify";

const DeletePayment: React.FC<{ paymentID: number }> = ({ paymentID }) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await accessURL.post(`payments/delete`, { paymentID });
      toast.success("Payment deleted successfully");

      setTimeout(() => {
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error("Failed to delete payment:", error);
      toast.error("Failed to delete payment");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <button
      onClick={handleDelete}
      disabled={isDeleting}
      className="text-red-600 hover:text-red-800 transition-colors"
      aria-label="Delete payment"
    >
      <Trash2 size={18} />
    </button>
  );
};

export default DeletePayment;
